import { useEffect, useState } from 'react';
import { notifyError } from '@/utils/Common/Notify';
import getEnquiryTypes from '@/api/get/enquiryTypes';
import getFormElements from '@/api/get/formElements';

export default () => {
  const [enquiryTypes, setEnquiryTypes] = useState(null);
  const [selectedEnquiry, setSelectedEnquiry] = useState({});
  const [formDynamicForm, setFormDynamicForm] = useState(null);

  const onSelectEnquiry = data => {
    setFormDynamicForm(null);
    setSelectedEnquiry(data);
  };

  const formElementsSuccessCB = data => {
    const hasFormElements = !data.message;
    setFormDynamicForm(null);
    if (hasFormElements) {
      setFormDynamicForm(data);
    } else {
      notifyError(data.message);
    }
  };

  useEffect(() => {
    getEnquiryTypes({ successCB: setEnquiryTypes });
  }, []);

  useEffect(() => {
    if (selectedEnquiry.code) {
      getFormElements({
        enquiryTypeCode: selectedEnquiry.code,
        successCB: formElementsSuccessCB,
      });
    } else {
      setFormDynamicForm(null);
    }
  }, [selectedEnquiry]);

  return { enquiryTypes, selectedEnquiry, onSelectEnquiry, formDynamicForm };
};
